var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 17200 5520",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "icon_svg__defs54"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style52"
  }, ".icon_svg__cls-2{fill:#f06b66}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon_svg__cls-2",
    d: "M192.82 277.51a27.5 27.5 0 1127.5-27.51 27.54 27.54 0 01-27.5 27.51z",
    id: "icon_svg__path56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon_svg__cls-2",
    d: "M8599.328 11359.997C3859.104 11359.997 0 7501.197 0 2759.999 0-1981.198 3859.104-5840 8599.328-5840S17200-1982.542 17200 2759.999a2773.717 2773.5 0 01-4230.456 2361.865l-39.867-24.636-22.847 41.209a4918.061 4917.677 0 11613.695-2378.438 903.07 903 0 101806.141 0c0-3709.197-3017.85-6726.812-6727.338-6726.812S1871.99-949.198 1871.99 2760 4889.392 9486.81 8599.328 9486.81a6716.587 6716.062 0 005125.014-2369.03l1433.446 1204a8583.65 8582.978 0 01-6558.46 3038.217zm0-11645.831a3049.207 3048.968 0 103048.758 3045.833 3052.343 3052.104 0 00-3048.758-3048.52z",
    id: "icon_svg__path58",
    strokeWidth: 44.793
  })));
}

export default SvgIcon;